/**
 * M-4: whether a course entry's form may open. An edit (`editingId` set)
 * opens only once its entry's list holds it: without the entry the form
 * would open empty, as a create, and its save would update the entry from
 * that empty or template form. Until then the form stays closed; it opens by
 * itself when the list arrives. A create (no `editingId`) always may open.
 */
export function editFormReady(
  editingId: string | null,
  entry: object | undefined,
): boolean {
  return editingId === null || entry !== undefined;
}
